export function splitEventByMonth(event) {
  const startDate = new Date(event.startDate + 'T00:00:00');
  const endDate = new Date(event.endDate + 'T00:00:00');

  // Vérifier si l'événement est dans le même mois
  if (startDate.getFullYear() === endDate.getFullYear() &&
      startDate.getMonth() === endDate.getMonth()) {
    return [event];
  }

  const events = [];
  const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
  const totalHours = parseInt(event.hours, 10) || 0;

  let currentYear = startDate.getFullYear();
  let currentMonth = startDate.getMonth();
  const monthlyHours = []; // Stocker les heures pour chaque mois

  // Première passe : calculer les heures proportionnelles
  while (true) {
    // Début de l'événement pour ce mois
    const monthStart = (currentYear === startDate.getFullYear() && currentMonth === startDate.getMonth())
      ? new Date(startDate)
      : new Date(currentYear, currentMonth, 1);

    // Fin de l'événement pour ce mois
    const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0);
    const monthEnd = (currentYear === endDate.getFullYear() && currentMonth === endDate.getMonth())
      ? new Date(endDate)
      : lastDayOfMonth;

    // Calculer le nombre de jours pour ce mois
    const daysInThisMonth = Math.ceil((monthEnd - monthStart) / (1000 * 60 * 60 * 24)) + 1;

    // Calculer les heures proportionnelles et arrondir
    const proportionalHours = (daysInThisMonth / totalDays) * totalHours;
    const roundedHours = Math.round(proportionalHours);

    monthlyHours.push({
      hours: roundedHours,
      monthStart,
      monthEnd,
      currentYear,
      currentMonth
    });

    // Arrêter si on a traité le mois de fin
    if (currentYear === endDate.getFullYear() && currentMonth === endDate.getMonth()) {
      break;
    }

    // Passer au mois suivant
    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
  }

  // Vérification et ajustement du total
  const currentTotal = monthlyHours.reduce((sum, month) => sum + month.hours, 0);
  const difference = totalHours - currentTotal;

  if (difference !== 0) {
    // Ajuster le dernier mois pour compenser la différence
    const lastMonthIndex = monthlyHours.length - 1;
    monthlyHours[lastMonthIndex].hours += difference;

    // S'assurer qu'on ne descend pas en dessous de 0
    if (monthlyHours[lastMonthIndex].hours < 0) {
      monthlyHours[lastMonthIndex].hours = 0;
      // Redistribuer sur les autres mois si nécessaire
      const remainingDifference = difference + monthlyHours[lastMonthIndex].hours;
      for (let i = monthlyHours.length - 2; i >= 0 && remainingDifference !== 0; i--) {
        monthlyHours[i].hours += remainingDifference;
        break;
      }
    }
  }

  // Deuxième passe : créer les événements
  monthlyHours.forEach((monthData, index) => {
    // Créer le titre
    let eventTitle = event.title;
    if (index > 0) {
      const monthName = monthData.monthStart.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
      eventTitle = `>> ${event.title}`;
    }

    // Formater les dates manuellement pour éviter les problèmes de timezone
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    // Créer l'événement pour ce mois
    const monthEvent = {
      ...event,
      startDate: formatDate(monthData.monthStart),
      endDate: formatDate(monthData.monthEnd),
      hours: monthData.hours,
      title: eventTitle
    };

    events.push(monthEvent);
  });

  return events;
}